import { getPassengerLocationApi } from "api/location";
import { useNotificationContext } from "contexts/NotificationContext";
import { jwtDecode } from "jwt-decode";
import { ERole } from "models/account";
import { IPassengerLocationData } from "models/location";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function useTrackPassenger() {
  const { showError } = useNotificationContext();
  const id: string = useParams().id!;
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [data, setData] = useState<IPassengerLocationData>();
  const [error, setError] = useState<string>("");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded: any = jwtDecode(token);
        if (decoded?.role === ERole.EMERGENCY_CONTACT) {
          const currentTime = Date.now() / 1000; // current time in seconds
          setIsAuthenticated((decoded.exp ?? 0) > currentTime);
          const intervalId = setInterval(fetchData, 10000);
          fetchData();
          
          // Cleanup interval on unmount
          return () => clearInterval(intervalId);
        } else setIsAuthenticated(false);
      } catch (error) {
        setIsAuthenticated(false);
      }
    } else setIsAuthenticated(false);
  }, []); // eslint-disable-line

  const fetchData = async () => {
    const { data, error: apiError } = await getPassengerLocationApi(id);
    if (data) {
      setData(data.data);
      setError("");
    } else {
      const errorMsg = apiError?.message ?? "Failed to fetch location";
      setError(errorMsg);
      // Only show error notification if it's not a "no ongoing trip" message
      if (!errorMsg.toLowerCase().includes("no ongoing trip")) {
        showError(errorMsg);
      }
    }
  };

  const handleCloseLogin = () => {
    setIsAuthenticated(true);
    fetchData();
    const intervalId = setInterval(fetchData, 10000);
    
    // Return cleanup function
    return () => clearInterval(intervalId);
  };
  
  return { data, isAuthenticated, handleCloseLogin, error };
}
